export type IconButtonSize = 'smaller' | 'small' | 'normal' | 'medium' | 'large'
export type IconButtonIconSize = 'small' | 'medium' | 'large'

// variant and color classes are handled by Button component

export const BASE_CLASSES =
  'flexbox flexbox-centered  flexbox-no-shrink transition'

export const iconButtonSize: Record<IconButtonSize, number> = {
  smaller: 20,
  small: 28,
  normal: 32,
  medium: 36,
  large: 44,
}
export const iconSizes: Record<IconButtonIconSize, number> = {
  small: 12,
  medium: 14,
  large: 16,
}
